import React from "react";
import withAuthority from "../../Auth/withAuthority";
import Authorities from "../../../auth/authorities";
import { Skeleton } from "@material-ui/lab";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import { CustomTheme } from "../../../types/customTheme";

export interface VoidSummeryProps {}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    rowOdd: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: "10px",
      border: `1px solid ${theme.palette.background.entity_border}`,
    },
  }),
);

const CardLoading: React.FunctionComponent<VoidSummeryProps> = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Skeleton
          variant="rect"
          className={classes.rowOdd}
          width={"100%"}
          height={200}
        />
      </Grid>
      <Grid item xs={4}>
        <Skeleton
          variant="rect"
          className={classes.rowOdd}
          width={"100%"}
          height={200}
        />
      </Grid>
      <Grid item xs={4}>
        <Skeleton
          variant="rect"
          className={classes.rowOdd}
          width={"100%"}
          height={200}
        />
      </Grid>
    </Grid>
  );
};

export default withAuthority(CardLoading, Authorities.DASHBOARD_READ);
